module.exports = __webpack_public_path__ + "static/media/AE.2dd6b5fe.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svgs/flags/AE.svg
// module id = 184
// module chunks = 0